import React, { useState } from "react";
import "./upi.css";

const UPI_ID = "8900191880@upi";

function UpiSection() {
  const [copied, setCopied] = useState(false);

  const copyUpiId = async () => {
    try {
      await navigator.clipboard.writeText(UPI_ID);
    } catch (e) {
      const input = document.createElement("input");
      input.value = UPI_ID;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="upi-section">
      <div className="container">
        <div className="upi-card">
          <div className="upi-qr">
            <img src="/upi.jpg" alt="Jhatka Byte UPI QR code" width="170" height="170" loading="lazy" />
          </div>
          <div className="upi-info">
            <h3 className="upi-title">
              Scan &amp; Pay with <span>UPI</span>
            </h3>
            <p className="upi-note">Use GPay, PhonePe, Paytm or any UPI app.</p>
            <div className="upi-id-pill">
              <span className="upi-id">{UPI_ID}</span>
              <button type="button" className="upi-copy" onClick={copyUpiId} aria-label="Copy UPI ID">
                <i className={copied ? "fas fa-check" : "far fa-copy"}></i>
                {copied ? "Copied" : "Copy"}
              </button>
            </div>
            <a href={`upi://pay?pa=${UPI_ID}&pn=JHATKABYTE`} className="upi-open-app d-md-none">
              <i className="fas fa-mobile-alt"></i>
              Open UPI App
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default UpiSection;
